export const rankStatus = {
    REGULAR: 'REGULAR',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
};
